import script from "./CatalogProductsControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogProductsControls.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogProductsControls.vue?vue&type=style&index=0&id=3bbd59fa&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bbd59fa"]])

export default __exports__